export const ROUTES = {
  products: '/products',
  catalog: '/catalog',
  search: '/search',
  discountedProducts: '/discounted-products',
  signIn: '/sign-in',
  signUp: '/sign-up',
  myAccount: '/my-account',
  checkout: '/checkout',
  clubMembershipCheckout: '/checkout/club-membership',
  clubMembership: '/club-membership',
  bikes: '/bikes',
  tenantManagement: '/tenant-management',
  ucp: '/ucp',
  rcsTestDevices: '/rcs-test-devices',
  registerRcsTestDevice: '/register-rcs-test-device'
};
